import React, {Component} from "react";
// import {Link} from "react-router-dom";
import {HashLink as Link} from "react-router-hash-link";
import ScrollToTop from "../routering/ScrollToTop";

export default class MenuItems extends Component{
    render() {
        let onMenuClicked = function(){
            //console.log("newWillMount");
            //console.log(document.querySelector("#bodyClick"));
            if(document.querySelector("#bodyClick") !== null){
                document.querySelector("html").classList.remove("nav-open");
                document.querySelector("#bodyClick").click();
            }
        };

        let setMenuBarState = function(){
            onMenuClicked();
            let checkInterval = setInterval(function(){
                // console.log(document.documentElement.scrollTop);

                let dom = document.querySelector(".navbar.navbar-expand-lg.fixed-top");
                if (document.documentElement.scrollTop > (document.querySelector(".page-header").clientHeight * 0.33) ){
                    if (dom.classList.contains("navbar-transparent")){
                        dom.classList.remove("navbar-transparent");
                    }
                    clearInterval(checkInterval);
                }

                if (document.documentElement.scrollTop === 0) clearInterval(checkInterval);

            }, 100);
        };

        let scrollToTop = function(){
            onMenuClicked();
            document.documentElement.scroll(0, 0);
        };



        return (
            <ul className="navbar-nav">

                <li className="nav-item">
                    <Link to="/" className="nav-link" rel="tooltip" title="Home" data-placement="bottom" onClick={scrollToTop} id='homeBtn' >
                        {/*<FontAwesomeIcon icon={faFileAlt} size="2x"/>*/}
                        <p className="d-lg-none ml-2">Home</p>
                    </Link>
                </li>

                <li className="nav-item">
                    <Link to="/#about-us" className="nav-link" rel="tooltip" title="About Us" data-placement="bottom" onClick={setMenuBarState}>
                        {/*<FontAwesomeIcon icon={faFileAlt} size="2x"/>*/}
                        <p className="ml-2">About Us</p>
                    </Link>
                </li>

                <li className="nav-item">
                    <Link to="/#contact-us" className="nav-link" rel="tooltip" title="Contact Us" data-placement="bottom" onClick={setMenuBarState}>
                        {/*<FontAwesomeIcon icon={faFileAlt} size="2x"/>*/}
                        <p className="ml-2">Contact Us</p>
                    </Link>
                </li>

                <li className="nav-item">
                    <Link to="/catalogue" className="nav-link" rel="tooltip" title="Download Catalog" data-placement="bottom" onClick={setMenuBarState}>
                        {/*<FontAwesomeIcon icon={faFileAlt} size="2x"/>*/}
                        <p className="ml-2">Catalogue</p>
                    </Link>
                </li>

                {/*<li className="nav-item">*/}
                {/*    <a href="../index.html" className="nav-link">*/}
                {/*        <i className="nc-icon nc-layout-11"></i> Components</a>*/}
                {/*</li>*/}
                {/*<li className="nav-item">*/}
                {/*    <a href="https://demos.creative-tim.com/paper-kit-2/docs/1.0/getting-started/introduction.html"*/}
                {/*       target="_blank" className="nav-link">*/}
                {/*        <i className="nc-icon nc-book-bookmark"/> Documentation</a>*/}
                {/*</li>*/}

                {/*<li className="nav-item">*/}
                {/*    <Link to="/about-us" className="nav-link" rel="tooltip" title="About Chuang Xing" data-placement="bottom">*/}
                {/*            /!*<FontAwesomeIcon icon={faFileAlt} size="2x"/>*!/*/}
                {/*            <p className="d-lg-none ml-2">About Us</p>*/}
                {/*    </Link>*/}
                {/*</li>*/}

                {/*<li className="nav-item">*/}
                {/*    <Link to="/contact-us" className="nav-link" rel="tooltip" title="Contact Chuang Xing" data-placement="bottom">*/}
                {/*            /!*<FontAwesomeIcon icon={faFileAlt} size="2x"/>*!/*/}
                {/*            <p className="d-lg-none ml-2">Contact Us</p>*/}
                {/*    </Link>*/}
                {/*</li>*/}

                {/*<li className="nav-item">*/}
                {/*    <a className="nav-link" rel="tooltip" title="Like us on Facebook" data-placement="bottom"*/}
                {/*       href="https://www.facebook.com/CreativeTim" target="_blank">*/}
                {/*        <i className="fa fa-facebook-square"></i>*/}
                {/*        <p className="d-lg-none">Facebook</p>*/}
                {/*    </a>*/}
                {/*</li>*/}
                {/*<li className="nav-item">*/}
                {/*    <a className="nav-link" rel="tooltip" title="Follow us on Instagram" data-placement="bottom"*/}
                {/*       href="https://www.instagram.com/CreativeTimOfficial" target="_blank">*/}
                {/*        <i className="fa fa-instagram"></i>*/}
                {/*        <p className="d-lg-none">Instagram</p>*/}
                {/*    </a>*/}
                {/*</li>*/}
                {/*<li className="nav-item">*/}
                {/*    <a className="nav-link" rel="tooltip" title="Star on GitHub" data-placement="bottom"*/}
                {/*       href="https://www.github.com/CreativeTimOfficial" target="_blank">*/}
                {/*        <i className="fa fa-github"></i>*/}
                {/*        <p className="d-lg-none">GitHub</p>*/}
                {/*    </a>*/}
                {/*</li>*/}
            </ul>
        )
    }
}